var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row form-group"},[_c('zahlungseingang-zuweisen-modal',{attrs:{"id":"zahlungseingang-zuweisen-modal","betrag":_vm.betrag},on:{"confirmed":_vm.onDebitorResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }